// STAR_URL_NAME과 STAR_ID 매핑
const STAR_ID_MAP: Record<string, number> = {
  jenna: 1,
  "4ever": 2,
}

// URL에서 스타 이름을 가져오는 함수 (항상 소문자로 반환)
export const getStarUrlName = (): string => {
  const pathname = window.location.pathname
  const segments = pathname.split("/").filter(Boolean)
  return (segments[0] || "4ever").toLowerCase()
}

// 현재 URL에서 스타 이름 가져오기
export const STAR_URL_NAME = getStarUrlName()
export const STAR_ID = STAR_ID_MAP[STAR_URL_NAME] || 1
